import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-page-blockframe',
    templateUrl: './page-blockframe.component.html',
    styleUrls: ['./page-blockframe.component.scss'],
})
export class PageBlockframeComponent {}
